// extracted by mini-css-extract-plugin
export default {"wrapper":"PanelItem_wrapper__zCdv0","box":"PanelItem_box__Kpb3V","title":"PanelItem_title__YAOBP","subtitle":"PanelItem_subtitle__WVDLJ","divNext":"PanelItem_divNext__EFaO8"};